import { render, staticRenderFns } from "./CallToActions.vue?vue&type=template&id=bef38e18&"
import script from "./CallToActions.vue?vue&type=script&lang=js&"
export * from "./CallToActions.vue?vue&type=script&lang=js&"
import style0 from "./CallToActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports